import { useState, useEffect } from 'react';
import { paymentService } from '../services/paymentService';
import { useAuth } from '../../auth/contexts/AuthContext';
import { message } from 'antd';

export function usePayments() {
    const { currentUser } = useAuth();
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchPayments = async () => {
        if (!currentUser) return;

        setLoading(true);
        try {
            const paymentList = await paymentService.getPayments(currentUser.uid);
            setPayments(paymentList);
        } catch (error) {
            message.error('Lỗi khi tải lịch sử thanh toán: ' + error.message);
        }
        setLoading(false);
    };

    const addPayment = async (paymentData) => {
        try {
            await paymentService.addPayment(currentUser.uid, paymentData);
            message.success('Thêm thanh toán thành công!');
            fetchPayments();
        } catch (error) {
            message.error('Lỗi khi thêm thanh toán: ' + error.message);
            throw error;
        }
    };

    const deletePayment = async (paymentId) => {
        try {
            await paymentService.deletePayment(currentUser.uid, paymentId);
            message.success('Xóa thanh toán thành công!');
            fetchPayments();
        } catch (error) {
            message.error('Lỗi khi xóa thanh toán: ' + error.message);
            throw error;
        }
    };

    useEffect(() => {
        fetchPayments();
    }, [currentUser]);

    return {
        payments,
        loading,
        addPayment,
        deletePayment,
        refetch: fetchPayments
    };
}
